import React from 'react';
import Hero from './components/Hero';
import WaterQuality from './components/WaterQuality';
import Features from './components/Features';
import WorkingProcess from './components/WorkingProcess';
import Specs from './components/Specs1';
import Contact from './components/Contact';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import AOS from 'aos';
import 'aos/dist/aos.css';

AOS.init();

export default function App() {
  return (
    <div className="font-sans bg-white text-gray-800">
      <Navbar />
      <WaterQuality />
      <Hero />
      <Features />
      <WorkingProcess />
      <Specs />
      <Contact />
      <Footer />
    </div>
  );
}
